import { UploadMultipleIcon } from './UploadMultipleIcon';

/**
 * author: Michael Richins
 * id 2B1A438E-4795-43D1-B4FD-3997C8E1BA9F
 * name upload-multiple
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/upload-multiple.svg
 * tags
 */
export const UploadsIcon = UploadMultipleIcon;
export default UploadsIcon